import api from './api';

export const userService = {
  getUsers: async (params) => {
    const response = await api.get('/teams', { params });
    return response.data;
  },
  createUser: async (data) => {
    const response = await api.post('/teams', data);
    return response.data;
  },
  updateUser: async (id, data) => {
    const response = await api.put(`/teams/${id}`, data);
    return response.data;
  },
};
